import styled from 'styled-components';
import { Theme } from '@veneer/theme';

export const SharedAccessContainer = styled.div<{ $veneerTheme: Theme }>`
  display: flex;
  flex-direction: column;
  gap: calc(
    ${({ $veneerTheme }) => $veneerTheme.layout.size8} +
      ${({ $veneerTheme }) => $veneerTheme.layout.size2}
  );
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ $veneerTheme }: { $veneerTheme: Theme }) =>
    $veneerTheme.layout.size4};
`;

export const TableHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DeviceImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 110px;
  height: 63px;
`;

export const ImagePlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 110px;
  height: 63px;
  background-color: ${({ $veneerTheme }: { $veneerTheme: Theme }) =>
    $veneerTheme.color.background.disabled};
`;

export const AccessRemainingText = styled.span<{
  $veneerTheme: Theme;
  $isExpiringSoon: boolean;
  $isExpired: boolean;
}>`
  color: ${({ $veneerTheme, $isExpiringSoon, $isExpired }) => {
    if ($isExpired) return $veneerTheme.color.foreground.light;
    if ($isExpiringSoon) return $veneerTheme.color.negative.base.default;
    return $veneerTheme.color.foreground.default;
  }};
`;

export const ErrorContainer = styled.div`
  width: 100%;
`;
